import gql from 'graphql-tag';

export const COST_CODE_DISPLAY_FRAGMENT = gql`
  fragment CostCodeDisplay on CostCode {
    id
    costCode
    title
  }
`;
